import React from 'react'

function streamList() {
    return (
        <div>
            streamList
        </div>
    )
}

export default streamList
